import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "prod-offer__block" };
const _hoisted_2 = { class: "prod-offer__label" };
const _hoisted_3 = { class: "prod-offer__list" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["name", "checked"];
const _hoisted_6 = { class: "prod-option__label" };
const _hoisted_7 = { key: 0 };
import { inject, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FilterSelector',
    props: /*@__PURE__*/ _mergeModels({
        name: { type: String, required: true },
        title: { type: String, required: true },
        items: { type: Array, required: true },
    }, {
        "modelValue": { required: false },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const modelValue = _useModel(__props, "modelValue");
        const interacted = inject('interacted');
        function computeActiveFilter(items) {
            var _a, _b;
            modelValue.value = (_b = (_a = items.find(item => { var _a, _b; return item.name === ((_a = modelValue.value) === null || _a === void 0 ? void 0 : _a.name) && item.flag === ((_b = modelValue.value) === null || _b === void 0 ? void 0 : _b.flag); })) !== null && _a !== void 0 ? _a : items.find(item => parseInt(item.volume) >= 15)) !== null && _b !== void 0 ? _b : items[0];
        }
        watch(() => props.items, computeActiveFilter);
        computeActiveFilter(props.items);
        function onClick(item) {
            interacted.value = true;
            modelValue.value = item;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1 /* TEXT */),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, key) => {
                        var _a, _b;
                        return (_openBlock(), _createElementBlock("li", {
                            class: "prod-offer__item",
                            key: key
                        }, [
                            _createElementVNode("label", {
                                class: _normalizeClass(["prod-option", { 'is-na': item.disabled }]),
                                onClick: ($event) => (onClick(item))
                            }, [
                                _createElementVNode("input", {
                                    type: "radio",
                                    class: "prod-option__input",
                                    name: __props.name,
                                    checked: item.name === ((_a = modelValue.value) === null || _a === void 0 ? void 0 : _a.name) && item.flag === ((_b = modelValue.value) === null || _b === void 0 ? void 0 : _b.flag)
                                }, null, 8 /* PROPS */, _hoisted_5),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_6, [
                                    _createTextVNode(_toDisplayString(item.name) + " ", 1 /* TEXT */),
                                    (item.flag)
                                        ? (_openBlock(), _createElementBlock("em", _hoisted_7, _toDisplayString(item.flag), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ], 10 /* CLASS, PROPS */, _hoisted_4)
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
